const reasons = [
  {
    tag: 'DOMAČA KUHINJA',
    title: 'Okusi domačega ognjišča.',
    desc: 'Tradicionalne slovenske jedi, pripravljene po receptih, ki se prenašajo iz roda v rod.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/e101ebbf386c71d7396975670c131308.png',
  },
  {
    tag: 'DRUŽINSKO VZDUŠJE',
    title: 'Toplina, ki te pospremi.',
    desc: 'Prostor, kjer se gostje vseh generacij počutijo kot doma – ob dobri hrani in prijazni besedi.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/29f8a11afc46af1a93824a77eee0ece3.png',
  },
  {
    tag: 'PRIREDITVE',
    title: 'Prostor za vsako praznovanje.',
    desc: 'Velika jedilnica za prireditve, praznovanja in družinska srečanja v prijetnem ambientu.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/97dc4ddb767ba32989ad9fb71ff7cba6.png',
  },
];

export default function ReasonsSection() {
  return (
    <section id="trenutki" className="relative bg-background-100 py-16 md:py-24 lg:py-32">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              ZAKAJ PRITI K NAM
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950">
              Trije razlogi za obisk
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {reasons.map((item, idx) => (
              <div
                key={idx}
                className="reason-card group relative overflow-hidden rounded-lg cursor-pointer transition-shadow duration-500"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`Gostilna Marta – ${item.tag.toLowerCase()}`}
                    className="absolute inset-0 w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent transition-opacity duration-500 pointer-events-none"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <p className="font-label text-[9px] tracking-extra-wide text-primary-400 font-semibold uppercase mb-1.5">
                    {item.tag}
                  </p>
                  <h3 className="font-heading text-lg md:text-2xl text-white font-light mb-2">
                    {item.title}
                  </h3>
                  <p className="font-body text-[11px] md:text-sm text-white/80 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
                <div className="absolute bottom-0 left-0 h-[2px] bg-accent-500 transition-all duration-500 w-0 group-hover:w-full"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}